//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
// import EstabelecimentoFinanceiroEdit from './EstabelecimentoFinanceiroEdit';
import EstabelecimentoFinanceiroListagemPage from './EstabelecimentoFinanceiroListagemPage';
import EstabelecimentoFinanceiroView from './EstabelecimentoFinanceiroView';

export default class EstabelecimentoFinanceiroIndex extends React.Component<{}> {
  render() {
    return (
      <Switch>
        <Route
          path="/estabelecimentoFinanceiro"
          component={EstabelecimentoFinanceiroListagemPage}
          exact
        />
        {/* <Route path="/estabelecimentoFinanceiro/novo" component={EstabelecimentoFinanceiroEdit} /> */}
        <Route
          path="/estabelecimentoFinanceiro/view/:id"
          component={EstabelecimentoFinanceiroView}
        />
      </Switch>
    );
  }
}
